import ApiService from "./apiService";




export async function getSpecialNotification() {
    const apiObject = {};
    apiObject.method = 'GET';
    apiObject.authentication = true;
    apiObject.endpoint = `student/public/institute`;
    apiObject.body = null;
    return await ApiService.callApi(apiObject);
}
